import { TagCommanderManager } from '../../services/tag-commander-manager';
import { HuitabModal } from '../common/huitab-modal';

/**
 * La modal de confirmation d'export et de consultation des tâches en cours
 */
export default class ModalSearchExportSuccess extends HuitabModal {
  /**
   * Initialise une nouvelle instance de type {@type ModalSearchExportSuccess}.
   */
  constructor() {
    super('modal-search-export-success');

    /**
     * Action pour réagir au clic "Consulter vos tâches".
     * @override
     */
    this.onAccept(() => {
      // Ouvre la liste des tâches au clic sur le bouton de la popin
      document.querySelector('lnc-web-task lnc-header-button')?.click();
    });
  }

  /**
   * Ouverture de la modal consulter mes taches
   */
  show() {
    super.show();
    // tag lors si la pop-in de confirmation s'ouvre
    TagCommanderManager.tagPage({
      chapitre_1: 'mes_taches',
      chapitre_2: 'vos_fichiers',
      chapitre_3: 'pop_in',
      page: 'confirmation_demande',
    });
  }
}
